import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useMediaQuery } from 'react-responsive';

function HeaderLoading() {
    const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
    const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  return (
    <div
    className="p-1 cover white gap-1"
    style={{
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(1, 1fr)"
        : isLaptop
        ? "repeat(2, 1fr)"
        : "repeat(4, 1fr)",
      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
    }}
  >
    {[...Array(4)].map((_, index) => (
      <div
        className="border-1px p-1 pointer border-radius-12"
        key={index}
      >
        <div className="valign-wrapper space-between">
          <Skeleton width={50} height={50} />
          <Skeleton width={30} height={30} />
        </div>
        <Skeleton width={120} height={20} />
        <div
          className="valign-wrapper font-13px"
          style={{ color: "#7C8DB5" }}
        >
          <Skeleton width={20} height={20} />
          <Skeleton
            width={80}
            height={20}
            style={{ marginLeft: "1rem", marginRight: "1rem" }}
          />
          <Skeleton width={80} height={20} />
        </div>
      </div>
    ))}
  </div>
  )
}

export default HeaderLoading
